import { render, staticRenderFns } from "./QuotationCreated.vue?vue&type=template&id=2bc3b745&scoped=true"
import script from "./QuotationCreated.vue?vue&type=script&lang=js"
export * from "./QuotationCreated.vue?vue&type=script&lang=js"
import style0 from "./QuotationCreated.vue?vue&type=style&index=0&id=2bc3b745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3b745",
  null
  
)

export default component.exports